export default __webpack_public_path__ + "static/media/journey_sl_init.096dfb86.png";